import {
  SET_DATA_SEARCH_FILTER,
  SET_VISIBLE_MODAL_ADV,
  RESET_SEARCH,
} from "../constants";

const initialState = {
  name: null,
  year: null,
  donViId: undefined,
  visible: false,
  keyword: null,
};

export default function searchFilterReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DATA_SEARCH_FILTER:
      return { ...state, ...action.payload };
    case SET_VISIBLE_MODAL_ADV:
      return { ...state, visible: action.payload };
    case RESET_SEARCH:
      return {
        ...state,
        name: null,
        year: null,
        donViId: undefined,
      };
    default:
      return state;
  }
}
